var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.tags)?_c('loading'):_c('div',[_c('div',{staticClass:"list-group w-100"},_vm._l((_vm.tags),function(tag){return _c('router-link',{key:tag,staticClass:"list-group-item list-group-item-action",attrs:{"to":{ name: 'documentation-tag-page', params: { tag: `${tag}` } }}},[_vm._v(_vm._s(tag))])}),1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }